export const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";

export const FETCH_ALL_BOOKINGS_REQUEST = "FETCH_ALL_BOOKINGS_REQUEST";
export const FETCH_ALL_BOOKINGS_SUCCESS = "FETCH_ALL_BOOKINGS_SUCCESS";
export const FETCH_ALL_BOOKINGS_FAILURE = "FETCH_ALL_BOOKINGS_FAILURE";

export const DELETE_BOOKING_REQUEST = "DELETE_BOOKING_REQUEST";
export const DELETE_BOOKING_SUCCESS = "DELETE_BOOKING_SUCCESS";
export const DELETE_BOOKING_FAILURE = "DELETE_BOOKING_FAILURE";

export const ADD_BOOKING_REQUEST = "ADD_BOOKING_REQUEST";
export const ADD_BOOKING_SUCCESS = "ADD_BOOKING_SUCCESS";
export const ADD_BOOKING_FAILURE = "ADD_BOOKING_FAILURE";

export const FETCH_BOOKING_REQUEST = "FETCH_BOOKING_REQUEST";
export const FETCH_BOOKING_SUCCESS = "FETCH_BOOKING_SUCCESS";
export const FETCH_BOOKING_FAILURE = "FETCH_BOOKING_FAILURE";

export const FETCH_SERVICE_TYPE_REQUEST = "FETCH_SERVICE_TYPE_REQUEST";
export const FETCH_SERVICE_TYPE_SUCCESS = "FETCH_SERVICE_TYPE_SUCCESS";
export const FETCH_SERVICE_TYPE_FAILURE = "FETCH_SERVICE_TYPE_FAILURE";

export const INSERT_INSTANT_BOOKING_REQUEST = "INSERT_INSTANT_BOOKING_REQUEST";
export const INSERT_INSTANT_BOOKING_SUCCESS = "INSERT_INSTANT_BOOKING_SUCCESS";
export const INSERT_INSTANT_BOOKING_FAILURE = "INSERT_INSTANT_BOOKING_FAILURE";

export const EDIT_BOOKING_REQUEST = "EDIT_BOOKING_REQUEST";
export const EDIT_BOOKING_SUCCESS = "EDIT_BOOKING_SUCCESS";
export const EDIT_BOOKING_FAILURE = "EDIT_BOOKING_FAILURE";

export const INSTANT_TOKEN_GENERATOR_REQUEST =
  "INSTANT_TOKEN_GENERATOR_REQUEST";
export const INSTANT_TOKEN_GENERATOR_SUCCESS =
  "INSTANT_TOKEN_GENERATOR_SUCCESS";
export const INSTANT_TOKEN_GENERATOR_FAILURE =
  "INSTANT_TOKEN_GENERATOR_FAILURE";
export const FETCH_TRANSIT_SERVICE_TYPE_REQUEST =
  "FETCH_TRANSIT_SERVICE_TYPE_REQUEST";
export const FETCH_TRANSIT_SERVICE_TYPE_SUCCESS =
  "FETCH_TRANSIT_SERVICE_TYPE_SUCCESS";
export const FETCH_TRANSIT_SERVICE_TYPE_FAILURE =
  "FETCH_TRANSIT_SERVICE_TYPE_FAILURE";
export const RESET_BOOKING_DETAILS = "RESET_BOOKING_DETAILS";

export const FETCH_CUSTOMER_BOOKINGS_REQUEST =
  "FETCH_CUSTOMER_BOOKINGS_REQUEST";
export const FETCH_CUSTOMER_BOOKINGS_SUCCESS =
  "FETCH_CUSTOMER_BOOKINGS_SUCCESS";
export const FETCH_CUSTOMER_BOOKINGS_FAILURE =
  "FETCH_CUSTOMER_BOOKINGS_FAILURE";

export const FETCH_COMPLEMENTARY_BOOKINGS_REQUEST =
  "FETCH_COMPLEMENTARY_BOOKINGS_REQUEST";
export const FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS =
  "FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS";
export const FETCH_COMPLEMENTARY_BOOKINGS_FAILURE =
  "FETCH_COMPLEMENTARY_BOOKINGS_FAILURE";

export const FETCH_INSTANT_BOOKINGS_REQUEST = "FETCH_INSTANT_BOOKINGS_REQUEST";
export const FETCH_INSTANT_BOOKINGS_SUCCESS = "FETCH_INSTANT_BOOKINGS_SUCCESS";
export const FETCH_INSTANT_BOOKINGS_FAILURE = "FETCH_INSTANT_BOOKINGS_FAILURE";

export const UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST =
  "UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST";
export const UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_SUCCESS =
  "UPDATE_BOOKING_DISCOUNT_STATUS_SUCCESS";
export const UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE =
  "UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE";

export const GET_ALL_BOOKINGS_REQUEST = "GET_ALL_BOOKINGS_REQUEST";
export const GET_ALL_BOOKINGS_SUCCESS = "GET_ALL_BOOKINGS_SUCCESS";
export const GET_ALL_BOOKINGS_FAILURE = "GET_ALL_BOOKINGS_FAILURE";
